export default __webpack_public_path__ + "static/media/book_image9.aaa7d9d3.jfif";